import { api } from "@/lib/http.ts";
import type {
  MemoryCreateReq,
  MemoryCreateStructuredReq,
  MemoryUpdateReq,
} from "@/types/memory.ts";
import type { Memory } from "./types.ts";

const BASE_API_PATH = "/api/a/memories";

export const updateMemory = async (memoryId: string, data: MemoryUpdateReq) => {
  return api.post(`${BASE_API_PATH}/${memoryId}`, data);
};

export const createMemory = async (data: MemoryCreateReq): Promise<Memory> => {
  const response = await api.post<Memory>(`${BASE_API_PATH}/new`, data);
  return response.data;
};

export const createStructuredMemory = async (data: MemoryCreateStructuredReq) => {
  return api.post(`${BASE_API_PATH}/create-structured`, data);
};

export const deleteMemory = async (memoryId: string) => {
  return api.post(`${BASE_API_PATH}/${memoryId}/delete`);
};
